import { useState, useEffect, useLayoutEffect } from "react";

import _ from "lodash";
import Container from "./components/Layout/Container";
import LeftCol from "./components/Layout/LeftCol";
import RightCol from "./components/Layout/RightCol";

import TtDebug from "./components/TtDebug";

import Viewer3d from "./components/Viewer3d";
import Wizard from "./components/Wizard";

import "./App.css";
import useFetch from "./hooks/useFetch";
import WizardButton from "./components/WizardButton";

const wizardUrl = process.env.REACT_APP_WIZZARD_SHED_ENDPOINT;
const wizardToken = process.env.REACT_APP_WIZZARD_SHED_TOKEN;

function App() {
  const [steps, setSteps] = useState(window.confCapannone);
  const [lang, setLang] = useState(document.documentElement.lang);
  const [change, setChange] = useState(0);
  const [direction, setDirection] = useState("forward");

  const [final, setFinal] = useState({});
  const [payload, setPayload] = useState({
    ...steps[Object.keys(steps).length - 1].config,
    language: lang,
  });
  const [currentStep, setCurrentStep] = useState(Object.keys(steps).length);
  const [call, data] = useFetch(wizardUrl, wizardToken, payload);

  const [rules, setRules] = useState({ 0: data });

  const [currentData, setCurrentData] = useState(data);
  useEffect(() => {
    call();
  }, []);

  useLayoutEffect(() => {
    if (payload) {
      call();
    }
  }, [payload]);

  useLayoutEffect(() => {
    if (direction == "back") {
      setCurrentData(rules[currentStep]);
    }
    if (currentStep - 1 < Object.keys(steps).length) {
      let newSteps = { ...steps };
      let newStep = {};
      newStep.config =
        newSteps[currentStep]?.config || newSteps[currentStep - 1]?.config;
      newSteps[currentStep] = newStep;
      setSteps(newSteps);
    }
  }, [currentStep]);

  useLayoutEffect(() => {
    if (steps[currentStep]) {
      setPayload({
        ...steps[currentStep - 1]?.config,
        ...steps[currentStep]?.config,
        change: change,
        language: lang,
      });

      setCurrentData(rules[currentStep]);
    } else {
      setPayload({
        ...steps[currentStep - 1]?.config,
        ...steps[currentStep]?.config,
        change: change,
        language: lang,
      });

      setCurrentData(data);
    }
  }, [JSON.stringify(steps[currentStep])]);

  useEffect(() => {
    if (!data) {
      return;
    }

    let newFinal = steps[currentStep].config;
    newFinal.wallcode = [];
    newFinal.tinsmith = [];
    newFinal.portal = {};
    newFinal.total = 0;
    newFinal.windows = 0;
    newFinal.bigDoors = 0;
    newFinal.smallDoors = 0;

    const _f = data.map((d) => {
      if (d.component?.items) {
        newFinal.items = d.component?.items;
      }
      if (d.holes) {
        newFinal.totWindows = d.holes.totWindows || 0;
        newFinal.totBigDoor = d.holes.totBigDoor || 0;
        newFinal.totSmallDoor = d.holes.totSmallDoor || 0;
      }
      if (d.wallcode) {
        if (d.type === "wall") {
          newFinal.wallcolorhex = d.color.trim();
        }
        if (d.type === "cover") {
          newFinal.covercolorhex = d.color.trim();
        }
        newFinal.wallcode = [...newFinal.wallcode, d];
      }
      if (d.tinsmith) {
        newFinal.tinsmith = [...newFinal.tinsmith, d.tinsmith];
        newFinal.tinsmithcolorhex = d.tinsmith.color.trim();
      }
      if (d.portal) {
        newFinal.portal = d.portal;
      }
    });
    newFinal.total = total(steps[currentStep].config);
    setFinal({ ...steps[currentStep].config, ...newFinal });
    if (currentStep - 1 < Object.keys(steps).length) {
      let newSteps = { ...steps };
      let newStep = { ...newSteps[currentStep], ...newFinal } || {};
      //newStep.rules = data;
      newSteps[currentStep] = newStep;
      setSteps(newSteps);
      let newRules = { ...rules };
      let newRule = data || {};
      newRules[currentStep] = newRule;
      setRules(newRules);
    }
    setCurrentData(data);
  }, [data]);

  function total(input) {
    const facePrice = input?.face?.price || 0;

    const footerPrice = input?.footer?.price || 0;

    let centralPrice = 0;
    if (input.central?.data) {
      centralPrice = input.central.data.reduce((acc, curr) => {
        return acc + curr?.price || 0;
      }, 0);
    }
    let wallPrice = 0;
    if (input?.wallcode) {
      wallPrice = input.wallcode.reduce((acc, curr) => {
        return acc + curr?.price * curr.qty || 0;
      }, 0);
    }
    let tinsmithPrice = 0;
    if (input?.tinsmith) {
      tinsmithPrice = input.tinsmith.reduce((acc, curr) => {
        return acc + curr?.price * curr.qty || 0;
      }, 0);
    }
    const portalPrice = input?.portal?.price * input?.portal?.qty || 0;

    let tot =
      facePrice +
      footerPrice +
      centralPrice +
      wallPrice +
      tinsmithPrice +
      portalPrice;
    return tot;
  }

  function handleChange(val) {
    setChange(0);
    if (val) {
      //setCurrentConfig({ ...currentConfig, ...val, step: currentStep || 0 });
      let newSteps = { ...steps };
      newSteps[currentStep].config = {
        ...steps[currentStep - 1]?.config,
        ...steps[currentStep].config,
        ...val,
      };

      setSteps(newSteps);
    }
  }

  function handleChangeArray(component, name, key, value) {
    //console.log(value);

    if (value.code) {
      setChange(0);
      let newArray = steps[currentStep].config[name]?.data || [];

      newArray[key] = value;

      const newObj = { data: newArray, items: component.items };

      // setCurrentConfig({
      //   ...currentConfig,
      //   [name]: newObj,
      //   step: currentStep || 0,
      // });
      let newSteps = { ...steps };
      newSteps[currentStep].config = {
        ...steps[currentStep].config,
        [name]: newObj,
        step: currentStep || 0,
      };

      setSteps(newSteps);
    }
  }

  function toIntIf(val) {
    return !isNaN(parseInt(val)) ? parseInt(val) : val;
  }
  //console.log("data", data);
  if (!data) {
    return <>laoding</>;
  }

  let { step } = currentData?.find((d) => d.step) ||
    data?.find((d) => d.step) || { step: { id: 0 } };

  async function handleSave() {
    if (step.endpoint) {
      try {
        console.log(step.apipayload);
        const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            ...step.apipayload,
            config_json: JSON.stringify(final),
            categoria: "capannone",
          }),
        };
        //return;
        console.log({ ...step.apipayload, config_json: JSON.stringify(final) });
        const res = await fetch(step.endpoint, requestOptions);
        console.log(await res.json());
        window.location.href = "/it/lp/thank-you-page1/";
      } catch (e) {
        window.location.href = "/it/lp/thank-you-page1/";
      }

      await fetch;
    }
    setChange(1);
    setDirection("forward");
    //console.log(currentStep, Object.keys(steps).length);
    if (currentStep < Object.keys(steps).length) {
      setCurrentStep(currentStep + 1);
    }
  }

  function handleBack() {
    setChange(0);
    if (
      window.confirm(
        "Andando indietro le opzioni selezionate in questa finestra verranno resettate, confermi di voler tornare indietro? "
      )
    ) {
      setDirection("back");

      let newSteps = { ...steps };
      //console.log(currentStep, Object.keys(newSteps));
      let stepsToRemove = Object.keys(newSteps).filter(
        (s) => parseInt(s) > parseInt(currentStep) - 1
      );
      //console.log(stepsToRemove);
      stepsToRemove.forEach((r) => delete newSteps[r]);
      //console.log(newSteps);
      setSteps(newSteps);
      if (currentStep <= 0) {
        setCurrentStep(0);
      } else {
        setCurrentStep(currentStep - 1);
      }
    }
  }

  return (
    <div
      className="wizard-main"
      style={{ width: "1570px", margin: "0 auto", backgroundColor: "#F5F5F5" }}
    >
      <Container>
        <LeftCol>
          <Viewer3d
            final={{
              //...steps[currentStep - 1]?.config,
              ...(steps[currentStep]?.config || {}),
              // ...(steps[currentStep]?.config || {}),
            }}
          />

          {/*
          <Order
            final={final}
            currentConfig={{
              ...steps[currentStep - 1]?.config,
              ...(steps[currentStep]?.config || {}),
            }}
            show={false}
          />
          */}
        </LeftCol>
        <RightCol>
          <div style={{ display: "flex" }}>
            <WizardButton
              enabled={step?.id > 1}
              icon="left"
              onClick={handleBack}
            >
              Back
            </WizardButton>

            <WizardButton
              enabled={step?.enableSave == 1}
              icon="right"
              onClick={handleSave}
            >
              Avanti
            </WizardButton>
          </div>
          <div
            style={{
              //padding: "2rem",
              paddingTop: "0",
              height: "579px",
              overflowY: "scroll",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <Wizard
              step={steps[currentStep]}
              data={currentData || data}
              handleChange={handleChange}
              currentConfig={steps[currentStep]?.config}
              //values={{ ...steps[currentStep + 1], ...currentConfig }}
              values={{
                ...steps[currentStep + 1]?.config,
                ...steps[currentStep]?.config,
              }}
              toIntIf={toIntIf}
              handleChangeArray={handleChangeArray}
              final={final}
              setFinal={setFinal}
            />
          </div>
        </RightCol>

        {/*container*/}
      </Container>

      <TtDebug
        x={[
          {
            title: "current step",
            data: {
              direction: direction,
              currentStep: currentStep,
              data: data,
            },
          },
          { title: "currentData", data: currentData },
          { title: "steps", data: steps },

          { title: "payload", data: payload },
          { title: "final", data: final },
        ]}
      ></TtDebug>

      {/*main*/}
    </div>
  );
}

export default App;
